export default __webpack_public_path__ + "images/referenzen/animationsfilm/tui_oneshare_animation.mp4";